
<template>
 <el-config-provider :locale="elLocale">
    <div id="app" class="app">
      <router-view/>
      <NoPermission/>
    </div>
  </el-config-provider>
</template>

<script>
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import { ElConfigProvider } from 'element-plus'
import { __browserVersions, __replaceDotCom } from '@/utils/tools.js'
import NoPermission from '@/views/common/noPermission/index.vue'
import { mapState } from 'vuex'
import { i18n } from './locale/index'
export default {
    components: { NoPermission, ElConfigProvider },
    computed: {
        ...mapState({ currentLanguage: state => state.common.lang }),
        elLocale() {
            return this.currentLanguage === 'en_US' ? en : zhCn
        }
    },
    watch: {
        currentLanguage(newLang) {
        if (i18n.global.locale.value !== newLang) {
            i18n.global.locale.value = newLang;
        }
        localStorage.setItem('language', newLang);
        this.iHelp();
    }
    },
    beforeCreate() {
        let href = window.location.href
        let queryStr = href.split('?')[1]
        let browserVersions = __browserVersions() // 浏览器信息
        let url = process.env.VUE_APP_BUILD_ENV === 'prod'
            ? 'https://eventsgo.huawei.com/eventsgo/mobile'
            : 'https://weblink01-ts.huawei.com/eventsgo/mobile'

        url = __replaceDotCom(url)
        if (browserVersions.mobile) {
            // 如果是移动端
            if (href.indexOf('/mediaPersonnel/mediaApplicationApproval') > -1) {
                // 如果是审批页面
                window.location.href = `${url}/#/approvalDetail?${queryStr}`
            } else {
                window.location.href = url
            }
        }
        setTimeout(() => {
            if (!window.BMap) {
                var script = document.createElement('script')
                script.src = process.env.VUE_APP_SCRIPT_SRC
                document.head.appendChild(script)
            }
        }, 10000)
    },
    created() {
        this.getOutsideUrlLookup()
        this.iHelp()
    },
    methods: {
        iHelp() {
            const ihelp = document.createElement('script')
            ihelp.id = 'ihelp_component_script'
            ihelp.type = 'text/javascript'
            ihelp.async = true
            ihelp.src = `https://app.huawei.com/wecare/onlineservice/cs.js?hotlineId=M003226&locale=${this.currentLanguage}`
            document.body.appendChild(ihelp)
        },

        /** 获取外部系统地址 */
        getOutsideUrlLookup() {
            this.$store.dispatch('common/getLookUpData', { classifyCode: 'OUTSIDE_URL' }).then((res) => {
                res.forEach(item => { this.$store.commit('common/setOutsideUrlMut', item) })
            })
        }
    }
}
</script>

<style lang="less">
@import './assets/css/common.less';
</style>
